import { HTMLAttributes } from "react"

type Props = HTMLAttributes<SVGElement>

export const Logo = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
      <path style={{ fill: '#27d08b' }} d="M33.9 38.4c2-1 3.5-2.6 4.5-4.5 1-2 1.6-3.9 1.6-9.2v-9.2c0-5.3-.6-7.3-1.6-9.2s-2.6-3.5-4.5-4.5S30 0 24.6 0h-9.2C10 0 8.1.6 6.1 1.6S2.6 4.2 1.6 6.1 0 10 0 15.4V40h24.6c5.4 0 7.3-.6 9.3-1.6zM4 36V15.4c0-4.9.5-6.1 1.1-7.4.7-1.2 1.7-2.2 2.9-2.9C9.3 4.5 10.5 4 15.4 4h9.2c4.9 0 6.1.5 7.4 1.1 1.3.7 2.2 1.6 2.9 2.9.7 1.2 1.1 2.5 1.1 7.4v9.2c0 4.9-.5 6.1-1.1 7.4-.7 1.3-1.6 2.2-2.9 2.9-1.2.7-2.5 1.1-7.4 1.1H4z" />
    </svg> 
  )
}
